<template>
  <div id="approve">
    <div v-if="isUnauth" class="unauth">
      <h3>Sorry, you do not have permission to approve this trip.</h3>
      <p>This likely occurred because you tried to approve a trip where you are not a direct approver and you do not have administrative access. If this is the case, please contact your organization's travel manager to arrange access.</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import useApi from "../utils/apiCalls.js";

const emit = defineEmits(["error"]);
const router = useRouter();
const route = useRoute();

// State
const isUnauth = ref(false);

// API utility
const { apiPutRequest } = useApi(emit);

// On component creation
onMounted(() => {
  const tripId = route.params.tripId;

  // API call to approve the trip
  apiPutRequest({
    path: `/trips/${tripId}/approve`,
    onSuccess: () => {
      // Redirect to the trip page
      router.push({ name: "trip", params: { tripId } });
    },
    onError: error => {
      if (error.response && error.response.status === 401) {
        isUnauth.value = true;
      } else {
        emit("error", error);
        alert("Sorry, you cannot access this trip. Please contact Flightfox or create a new trip below.");
      }
    },
  });
});
</script>

<style lang="less">
#approve {
  .unauth {
    margin: auto;
    max-width: 36rem;
    text-align: center;
  }
}
</style>
